import UnderConstrcutionIcon from '../../common/icons/under-construction-icon';

export default function UnderConstructionPage() {
  return (
    <div className="grc-card d-flex align-items-center justify-content-center text-primary fw-bold">
      <UnderConstrcutionIcon />
    </div>
  );
}
